export const defaultExclusions = [
  {
    name: "ero",
    magnitude: 0,
    id: "e612d292-f5d6-4817-abfc-893a83d68de2"
  },
  {
    name: "pantsu",
    magnitude: 3,
    id: "9be012d3-a895-44d0-8916-accb0507a23b"
  },
  {
    name: "oppai",
    magnitude: 2,
    id: "9be012d3-a895-44d0-8916-accb0507a23b"
  },
];